__turbopack_context__.v({
  "carousel": "pznMessageHero-module-scss-module__urYhMW__carousel",
  "center": "pznMessageHero-module-scss-module__urYhMW__center",
  "container": "pznMessageHero-module-scss-module__urYhMW__container",
  "shell": "pznMessageHero-module-scss-module__urYhMW__shell",
});
